import { Component, OnInit } from '@angular/core';
import { OurServiceService } from '../../services/our-service.service';
import { OurServiceModel } from '../../models/service.model';
import { OurProjectService } from '../../services/our-project.service';
import { OurProjectsModel } from '../../models/our-projects.model';
import { BlogService } from '../../services/blog.service';
import { BlogModel } from '../../models/blog.model';
import { SiteMassageService } from '../../services/site-massage.service';
import { SiteMassageModel } from '../../models/site-massage.model';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { TeamService } from '../../services/team.service';
import { TeamModel } from '../../models/team.model';
import { NgForOf } from "../../../../../node_modules/@angular/common/index";
@Component({
  selector: 'app-index-blog',
  templateUrl: './index-blog.component.html',
  styleUrls: ['./index-blog.component.css'],
})

/***
 * Blog Component
 */
export class IndexBlogComponent implements OnInit {

    images = [700, 800, 807].map((n) => `https://picsum.photos/id/${n}/900/500`);


currentLang = localStorage.getItem('lang') || 'ar';
    // Set Topbar Option
    Menuoption = 'blog';
  /***
   * Nav bg light calss Add
   */
  navClass = 'navbar-white-bg';
  Settingicon = true
  footerVariant = 'footer-nine';

  /***
   * Main Slider navigation Add
   */
  showNavigationArrows = true;
  showNavigationIndicators = true;

  /**
   * Blog Data
   */
   blogData = [
    {
      image: "assets/images/blog/01.jpg",
      title: "Design your apps in your own way",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/02.jpg",
      title: "How apps is changing the IT world",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/03.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    }
  ];

  /**
   * Resent Post Data
   */
   resentPostData = [
    {
      image: "assets/images/blog/04.jpg",
      title: "How apps is changing the IT world",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/05.jpg",
      title: "Design your apps in your own way",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    },
    {
      image: "assets/images/blog/06.jpg",
      title: "Smartest Applications for Business",
      like: "33",
      message: "08",
      name: "Calvin Carlo",
      date: "13th August, 2019"
    }
  ];
blogs:BlogModel[]=[];
  constructor(private TeamService:TeamService, private ourService: OurServiceService,private ourProjectService: OurProjectService,private blogService:BlogService,config: NgbCarouselConfig) {

     config.interval = 2000;
    config.keyboard = true;
    config.pauseOnHover = true;
   }


      ourservices:OurServiceModel[] = [];
ourprojects: OurProjectsModel[] = [];
temamembers: TeamModel[] = [];
  ngOnInit(): void {
    this.ourService.GetLasted().subscribe((res: any) => {
      this.ourservices = res;
      
    });
    this.ourProjectService.GetLasted().subscribe((res: any) => {
      this.ourprojects = res;
    });
    this.blogService.GetLasted()
    .subscribe(result =>{
      this.blogs = result;
    })
    this.TeamService.BoardMembers()
    .subscribe(result =>{
      this.temamembers = result;
    })
  }

  /***
   * Follow Slider
   */
  public config = {
    infinite: false,
    slidesToShow: 10,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true
  };

}
